import rootFontSizes from '../constants/root_font_sizes';

const pxToRelativeUnit = (px: number, unit: string, root: number) =>
  `${Number((px / root).toFixed(2))}${unit}`;

export const pxToEm = (px: number) => pxToRelativeUnit(px, 'em', rootFontSizes.browser);
export const pxToRem = (px: number) => pxToRelativeUnit(px, 'rem', rootFontSizes.app);
